import React, { useState } from "react";
import "./Cadastro.css";
import "../../../pages/Login/reset.css";
import { verificarCpf, verificarCnpj, verificarUserName, habilitarBotaoProximoPF, habilitarBotaoProximoPJ, onSubmitPJ, onSubmitPF } from "./functions";

import { Button } from "../../../components/Button";
import CadastroAcesso from "../../../components/CadastroAcesso";
import { CadastroDadosCadastrais } from "../../../components/CadastroDadosCadastrais";
import { CadastroDocumentos } from "../../../components/CadastroDocumentos";
import { CadastroServicos } from "../../../components/CadastroServicos";
import { Loading } from "../../../components/Loading";
import { Erro } from "../AlteracaoSenha/AlteracaoSenha";
import { AuthShell } from "../../../components/AuthShell";
import { useNavigate } from "react-router-dom";


export interface ImagensDocumentacao {
    tipoDocumento: string;
    conteudo: string | ArrayBuffer | null;
    nomeArquivo: string;
    tamanho: string;
    dataUpload: string;
}
export interface Endereco {
    rua: string;
    bairro: string;
    cidade: string;
    estado: string;
    complemento: string;
    cep: string;
}

export interface Usuario {
    nome: string,
    cpf: string,
    profissao: string,
    renda: number,
    telefone: string,
    dataNascimento: string,
    nacionalidade: string,
    estadoCivil: "Solteiro" | "Casado" | "Divorciado" | "Separado" | "Viúvo",
    endereco: Endereco | undefined,
}

export interface UsuarioPJ {
    nome: string,
    razaoSocial: string,
    cnpj: string,
    telefone: string,
    endereco: Endereco | undefined,
    socios: Socios[]
}

export interface Socios {
    nome: string,
    endereco: Endereco | undefined,
}

function Cadastros() {
    const [active, setActive] = useState<number>(1);
    const [userName, setUserName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [senha, setSenha] = useState<string>("");
    const [senhaConfirmada, setSenhaConfirmada] = useState<string>("");
    const [opcaoSelecionada, setOpcaoSelecionada] = useState<string>("");
    const [imagePerfil, setImagePerfil] = useState<string | ArrayBuffer | null>("");
    const [idsServicosFinanceiros, setIdsServicosFinanceiros] = useState<Array<number>>([]);
    const [imagensDocumentacao, setImagensDocumentacao] = useState<Array<ImagensDocumentacao>>([]);
    const [loading, setLoading] = useState(false);
    const [compromisso, setCompromisso] = useState<boolean>(false);
    const [error, setError] = useState<Erro>({ erro: false, mensagem: "", });
    const [socios, setSocios] = useState<Socios[]>([]);
    const [confirmouEnvioSemDocumentosComplementaresPJ, setConfirmouEnvioSemDocumentosComplementaresPJ] = useState(false);
    const [usuarioPJ, setUsuarioPJ] = useState<UsuarioPJ>({
        nome: '',
        cnpj: "",
        endereco: {
            rua: '',
            bairro: '',
            cidade: '',
            estado: '',
            complemento: '',
            cep: '',
        },
        razaoSocial: "",
        telefone: "",
        socios: []
    });
    const [usuarioPF, setUsuarioPF] = useState<Usuario>({
        nome: "",
        cpf: '',
        profissao: '',
        renda: 0,
        telefone: '',
        dataNascimento: "",
        nacionalidade: '',
        estadoCivil: "Solteiro",
        endereco: {
            rua: '',
            bairro: '',
            cidade: '',
            estado: '',
            complemento: '',
            cep: '',
        }
    });

    const navigate = useNavigate();
    const cadastroSteps: Array<{ label: string; content: React.ReactNode }> = [
        {
            label: "ACESSO",
            content: (
                <CadastroAcesso
                    userName={userName}
                    setUserName={setUserName}
                    setEmail={setEmail}
                    setPassword={setSenha}
                    setImagePerfil={setImagePerfil}
                    senha={senha}
                    setSenhaConfirmada={setSenhaConfirmada}
                    setError={setError}
                />
            ),
        },
        {
            label: "DADOS CADASTRAIS",
            content: (
                <CadastroDadosCadastrais
                    usuarioPF={usuarioPF}
                    setUsuarioPF={setUsuarioPF}
                    setUsuarioPJ={setUsuarioPJ}
                    socios={socios}
                    setSocios={setSocios}
                    setOpcaoSelecionada={setOpcaoSelecionada}
                />
            ),
        },
        {
            label: "SERVIÇOS",
            content: (
                <CadastroServicos
                    idsServicosFinanceiros={idsServicosFinanceiros}
                    setIdsServicosFinanceiros={setIdsServicosFinanceiros}
                />
            ),
        },
        {
            label: "DOCUMENTOS",
            content: (
                <CadastroDocumentos
                    tipoPessoa={opcaoSelecionada}
                    setCompromisso={setCompromisso}
                    setImagensDocumentacao={setImagensDocumentacao}
                    setError={setError}
                />
            ),
        },
    ];

    return (
        <AuthShell
            eyebrow="Cadastro Omex Capital"
            title="Abra sua conta com visão de mercado"
            subtitle="Um fluxo direto para conectar perfil, serviços e documentos em uma experiência mais clara e institucional."
            onLogoClick={() => navigate("/")}
            variant="wide"
        >
            <section className="auth-wide-card cadastro-auth-card" aria-label="Cadastro Omex Capital">
                {loading && <Loading />}
                <div className="cadastro-card-header">
                    <p className="auth-card-kicker">Onboarding digital</p>
                    <h2 className="auth-card-title">Cadastro de cliente</h2>
                    <p className="auth-card-copy">
                        Complete as etapas abaixo para solicitar seu acesso à Omex Capital.
                    </p>
                </div>

                    <div className="CadastroStepper" aria-label="Etapas do cadastro">
                        {cadastroSteps.map((step, index) => {
                            const stepNumber = index + 1;
                            const isActive = stepNumber === active;
                            const isComplete = stepNumber < active;

                            return (
                                <button
                                    key={step.label}
                                    className={`CadastroStepperItem ${isActive ? "active" : ""} ${isComplete ? "complete" : ""}`}
                                    type="button"
                                    onClick={() => setActive(stepNumber)}
                                    disabled={stepNumber > active}
                                    aria-current={isActive ? "step" : undefined}
                                >
                                    <span className="CadastroStepperNumber">{stepNumber}</span>
                                    <span className="CadastroStepperLabel">{step.label}</span>
                                </button>
                            );
                        })}
                    </div>
                    <div className="CadastroStepContent">
                        {cadastroSteps[active - 1]?.content}
                    </div>
                {error.erro && <p className="auth-message">{error.mensagem}</p>}
                <div className="Container_Botoes">
                    {active > 1 && (
                        <div className="Area_Botoes">
                            <Button
                                classNameButton="auth-secondary-button"
                                onClick={() => {
                                    setActive(active - 1);
                                }}
                                titleButton="Anterior"
                            />
                        </div>
                    )}
                    <div className="Area_Botoes">
                        <Button
                            classNameButton="auth-primary-button cadastro-next-button"
                            onClick={() => {

                                if (opcaoSelecionada === 'PessoaFisica') {

                                    if (habilitarBotaoProximoPF(
                                        active,
                                        setError,
                                        userName,
                                        email,
                                        senha,
                                        senhaConfirmada,
                                        imagePerfil,
                                        usuarioPF,
                                        idsServicosFinanceiros,
                                        imagensDocumentacao
                                    )) {
                                        active === 1 && verificarUserName(setLoading, userName, setError, email, setActive);
                                        active === 2 && verificarCpf(setLoading, setError, usuarioPF.cpf, setActive);
                                        active === 3 && setActive(active + 1);
                                        if (active === 4) {
                                            if (compromisso) {
                                                onSubmitPF(
                                                setLoading,
                                                setError,
                                                userName,
                                                email,
                                                senha,
                                                imagePerfil,
                                                usuarioPF,
                                                idsServicosFinanceiros,
                                                imagensDocumentacao,
                                                navigate
                                                );
                                            } else {
                                                setError({
                                                    erro: true,
                                                    mensagem: "Aceite o termo de compromisso para seguir."
                                                });
                                            }
                                        }
                                    }
                                } else {
                                    const cartaoCnpjAnexado = imagensDocumentacao.some(
                                        (documento) => documento.tipoDocumento === "CNPJ"
                                    );
                                    const documentosComplementaresAusentes = ["ContratoSocial", "ComprovanteDeResidencia"].some(
                                        (tipo) => !imagensDocumentacao.some((documento) => documento.tipoDocumento === tipo)
                                    );
                                    const deveConfirmarEnvioSemDocumentosComplementares = active === 4
                                        && cartaoCnpjAnexado
                                        && documentosComplementaresAusentes
                                        && !confirmouEnvioSemDocumentosComplementaresPJ;

                                    const podeAvancar = habilitarBotaoProximoPJ(
                                        active,
                                        setError,
                                        userName,
                                        email,
                                        senha,
                                        senhaConfirmada,
                                        imagePerfil,
                                        usuarioPJ,
                                        socios,
                                        idsServicosFinanceiros,
                                        imagensDocumentacao,
                                        confirmouEnvioSemDocumentosComplementaresPJ
                                    );

                                    if (deveConfirmarEnvioSemDocumentosComplementares)
                                        setConfirmouEnvioSemDocumentosComplementaresPJ(true);

                                    if (podeAvancar) {
                                        active === 1 && verificarUserName(setLoading, userName, setError, email, setActive);
                                        active === 2 && verificarCnpj(setLoading, setError, usuarioPJ.cnpj, setActive);
                                        active === 3 && setActive(active + 1);
                                        if (active === 4) {
                                            if (compromisso) {
                                                onSubmitPJ(
                                                setLoading,
                                                setError,
                                                userName,
                                                email,
                                                senha,
                                                imagePerfil,
                                                usuarioPJ,
                                                socios,
                                                idsServicosFinanceiros,
                                                imagensDocumentacao,
                                                navigate
                                                );
                                            } else {
                                                setError({
                                                    erro: true,
                                                    mensagem: "Aceite o termo de compromisso para seguir."
                                                });
                                            }
                                        }
                                    }
                                }

                            }}
                            titleButton={active === 4 ? "Concluir" : "Próximo"}
                        />
                    </div>
                </div>
            </section>
        </AuthShell>
    );
}
export default Cadastros;
